import M from "moment";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Api from "../../../Services/Api";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleDate from "../../../modules/SimpleDate";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import {mapToObjectDDL, removeNullFields} from "../../common/mapper";
import PoUnitDetail from "./poUnitDetail";
import PoUnitFilter from "./poUnitFilter";
import {fetchDataAsync, getUserAccess} from "../../../Services/Utils";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {HttpStatus} from "../../common/Constants";
import SimpleMonthYearPicker from "../../../modules/SimpleMonthYearPicker";
import {DateObject} from "react-multi-date-picker";

const DATE_FORMAT = "DD-MM-YYYY";

class PoUnit extends Component {

    getIconsAksi = (type = "preview") => {
        const iconMap = {
            edit: "pencil-alt",
            delete: "trash",
            preview: "eye",
        };

        const accessMap = {
            edit: this.state.userAccess.updateAccess,
            delete: this.state.userAccess.deleteAccess,
            preview: true,
        };

        const iconClass = iconMap[type] || iconMap.preview;
        const hasAccess = accessMap[type] ?? accessMap.preview;
        const color = hasAccess ? "red" : "grey";

        return (
            <i
                className={`fa fa-lw fa-${iconClass}`}
                style={{
                    backgroundColor: "transparent",
                    color,
                    fontSize: 20,
                }}
            />
        );
    };


    tableColumns = [
        {
            name: "id",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "poNo",
            label: "Nomor PO",
        },
        {
            name: "poDate",
            label: "Tanggal PO",
        },
        {
            name: "poMonth",
            label: "PO Month",
        },
        {
            name: "qtyFix",
            label: "Qty Fix",
        },
        {
            name: "qtyTent1",
            label: "Qty Tent 1",
        },
        {
            name: "qtyTent2",
            label: "Qty Tent 2",
        },
        {
            name: "poNo",
            label: "Aksi",
            options: {
                customBodyRender: (val) => (
                    <FlexView>
                        <SimpleButton
                            category="action_button"
                            className="btnAct margin-right-15px"
                            styles={{backgroundColor: "transparent"}}
                            icon={this.getIconsAksi('preview')}
                            onClick={() => {
                                this.handleDetailVisibility(val, 'preview');
                            }}
                        />
                        <SimpleButton
                            category="action_button"
                            disabled={!this.state.userAccess.updateAccess}
                            className="btnAct margin-right-15px"
                            styles={{backgroundColor: "transparent"}}
                            icon={this.getIconsAksi('edit')}
                            onClick={() => {
                                this.handleDetailVisibility(val, 'edit');
                            }}
                        />
                        <SimpleButton
                            category="action_button"
                            disabled={!this.state.userAccess.updateAccess}
                            className="btnAct margin-right-15px"
                            styles={{backgroundColor: "transparent"}}
                            icon={this.getIconsAksi('delete')}
                            onClick={() => {
                                this.handleDetailVisibility(val, 'delete');
                            }}
                        />
                    </FlexView>
                ),
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            detail: {
                poNo: "",
                visible: false,
            },
            filterVisible: false,
            printVisible: false,
            loading: false,
            searchData: {
                tanggalAwal: null,
                tanggalAkhir: null,
            },
            filterData: {},
            submittedFilterData: {},
            kodeCabang: null,
            pagination: {
                totalData: 1,
                page: 1,
                limit: 5,
            },
            cabangOptions: [],
            dataTable: [],
            userAccess: {},
            skipPagination: false
        };
    }

    componentDidMount() {
      this.fetchDataCabang()
    }

    fetchDataCabang = async () => {
      const { menuAccess, setError } = this.props;
      this.handleLoadingVisibility();
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
        setError: setError,
        menuName: "PO UNit",
        args: null,
      });
    
      if (res.ok) {
        const filteredData = res.data.data.filter((item) =>
          menuAccess.map((data) => data.idRefObj).includes(item.kodeCabang),
        );
    
        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            cabangOptions: filteredData.map((item) => ({
              ...item,
              label: item.namaDealer,
              value: item.kodeCabang,
            })),
            kodeCabang: {
              label: filteredData[0].namaDealer,
              value: filteredData[0].kodeCabang,
            },
            userAccess: getUserAccess(menuAccess, filteredData[0].kodeCabang),
          }));
        }
        await this.fetchData({
          kodeCabang: filteredData[0].kodeCabang,
        });
      }
      this.handleLoadingVisibility();
    };

    async componentDidUpdate(_, prevState) {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) && !this.state.skipPagination
        ) {
            this.handleLoadingVisibility()
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleLoadingVisibility()
        }
        if (this.state.skipPagination) {
            this.setState({skipPagination: false})
        }
    }

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getAllPOUnit,
            menuName: "PO Unit",
            setError: this.props.setError,
            args: {
                paramFilters: {
                    ...filter,
                    kodeCabang: filter?.kodeCabang || this.state.kodeCabang?.value || "",
                },
                page,
                limit,
            },
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                },
                dataTable: response.data.data?.map((dt) => ({
                    ...dt,
                    poDate: M(dt.poDate, "DD/MM/YYYY").format("DD-MM-YYYY"),
                })),
            }));
        }
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handlePrint = () => {
        this.setState((prevValue) => ({...prevValue, printVisible: !prevValue.printVisible}));
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {
                ...prevValue.searchData,
                [name]: value,
            },
        }));
    };

    handleSearch = async () => {
        this.handleLoadingVisibility()
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                poDate: {...this.poDateInitialData},
            },
            pagination: {
                ...prevValue.pagination,
                page: 1,
            },
            skipPagination: true
        }));
        const request = removeNullFields({
            poMonth: removeNullFields({
                tanggalAwal: this.state.searchData?.tanggalAwal
                    ? M(this.state.searchData?.tanggalAwal.format(DATE_FORMAT), DATE_FORMAT).startOf('month').format(DATE_FORMAT)
                    : "",
                tanggalAkhir: this.state.searchData?.tanggalAkhir
                    ? M(this.state.searchData?.tanggalAkhir.format(DATE_FORMAT), DATE_FORMAT).endOf('month').format(DATE_FORMAT)
                    : "",
            }),
        });
        await this.fetchData(request, this.state.pagination.page, this.state.pagination.limit);
        this.setState((prevValue) => ({...prevValue, submittedFilterData: request, loading: false}));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleSubmitFilter = async () => {
        this.handleLoadingVisibility()
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {
                ...prevValue.searchData,
                tanggalAwal: null,
                tanggalAkhir: null,
            },
            pagination: {
                ...prevValue.pagination,
                page: 1,
            },
            skipPagination: true
        }));
        const request = removeNullFields({
            ...this.state.filterData,
            poMonth: this.state.filterData.poMonth
                ? this.state.filterData.poMonth.format("MMMM YYYY")
                : "",
            poDate: removeNullFields({
                tanggalAwal: this.state.filterData.poDate?.tanggalAwal
                    ? M(this.state.filterData.poDate.tanggalAwal).format(DATE_FORMAT)
                    : "",
                tanggalAkhir: this.state.filterData.poDate?.tanggalAkhir
                    ? M(this.state.filterData.poDate.tanggalAkhir).format(DATE_FORMAT)
                    : "",
            }),
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: request,
            loading: false,
            filterVisible: false,
        }));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({...prevValue, filterVisible: !prevValue.filterVisible}));
    };

    handleLoadingVisibility = () => {
        this.setState((prev) => ({
            ...prev,
            loading: !prev.loading,
        }));
    }

    handleRefresh = async () => {
        // this.setState((prev) => ({
        //     ...prev,
        //     pagination: {
        //         ...prev.pagination,
        //         page: 1,
        //     },
        //     skipPagination: true,
        // }));

        this.handleLoadingVisibility()

        await this.fetchData(
          {
            ...this.state.submittedFilterData,
            kodeCabang: this.state.kodeCabang.value,
          },
          this.state.pagination.page,
          this.state.pagination.limit,
        );

        this.handleLoadingVisibility()
    }

    handleCabangChange = async (name, value) => {
      this.setState(
        (prevValue) => ({
          ...prevValue,
          [name]: value,
          userAccess: getUserAccess(this.props.menuAccess, value.value),
          pagination: {
            totalData: 1,
            page: 1,
            limit: 5,
          },
          skipPagination: true,
          submittedFilterData: null
        }),
        async () => {
          this.handleLoadingVisibility();
          await this.fetchData({
            kodeCabang: this.state.kodeCabang.value,
          });
          this.handleLoadingVisibility();
        },
      );
    };

    handleDetailVisibility = (poNo = "", aksi) => {
        this.setState((prevValue) => ({
            ...prevValue,
            detail: {
                poNo: poNo,
                cabang: this.state.kodeCabang,
                visible: !prevValue.detail.visible,
                aksi,
            },
        }));
    };

    handleCloseModalDetail = (refresh) => {
        if (refresh) {
            this.handleRefresh()
        }
        this.setState((prev) => ({
            ...prev,
            detail: {
                ...prev.detail,
                poNo: null,
                aksi: null,
                visible: !prev.detail.visible,
            },
        }));
    }

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between"}}
                        vAlignContent="center"
                        className="margin-top-5px"
                    >
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleDDL
                                id="select_options_nama_cabang"
                                box="search"
                                name="kodeCabang"
                                containerclassname="width width-250px"
                                placeholder="Nama cabang hak akses"
                                options={this.state.cabangOptions}
                                value={this.state.kodeCabang}
                                onChange={(value, {name}) => this.handleCabangChange(name, value)}
                            />
                            <p className="margin-left-25px margin-bottom-20px">Periode PO</p>
                            <SimpleMonthYearPicker
                                id="select_date_startDateSL"
                                name="tanggalAwal"
                                value={this.state.searchData.tanggalAwal}
                                maxDate={this.state.searchData.tanggalAkhir}
                                onChange={(value) => this.handleSearchValueChange("tanggalAwal", value)}
                            />
                            <SimpleMonthYearPicker
                                id="select_date_endDateSL"
                                name="tanggalAkhir"
                                value={this.state.searchData.tanggalAkhir}
                                minDate={this.state.searchData.tanggalAwal}
                                onChange={(value) => this.handleSearchValueChange("tanggalAkhir", value)}
                            />
                            <SimpleButton className="margin-bottom-20px" onClick={this.handleSearch}>
                                Cari
                            </SimpleButton>
                        </FlexView>
                        <SimpleButton
                            type="button"
                            category="action_button"
                            className="btn background-red margin-bottom-20px"
                            onClick={this.handleFilterVisibility}
                            icon={<i className="fa fa-qrcode"></i>}
                        />
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        toCount={this.state.pagination.totalData}
                        options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                        footerAdditionalButtons={
                            <>
                                <SimpleButton
                                    disabled={!this.state.userAccess?.createAccess}
                                    secondary={!this.state.userAccess?.createAccess}
                                    icon={<i className="fa fa-plus margin-right-10px"/>}
                                    onClick={() => this.handleDetailVisibility(null, 'create')}
                                >
                                    Buat PO
                                </SimpleButton>
                                {/* <SimpleButton onClick={this.handlePrint}>
                                    Cetak
                                </SimpleButton> */}
                            </>
                        }
                    />
                </Container>
                {this.state.printVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}
                {this.state.filterVisible && (
                    <PoUnitFilter
                        state={this.state}
                        onClickClose={this.handleFilterVisibility}
                        onSetState={this.handleStateChange}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.detail.visible && (
                    <PoUnitDetail
                        state={this.state}
                        onClickClose={this.handleCloseModalDetail}
                        isCanDelete={this.state.userAccess.deleteAccess}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(PoUnit);
